var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-card',{staticClass:"box-card"},[_c('strong',{staticStyle:{"margin-top":"10px","margin-left":"10px"}},[_vm._v("包签剩余总量")]),_c('div',{staticClass:"label-total-count-p"},[_c('div',{staticClass:"__total_count__"},[_vm._v(_vm._s(_vm.format(_vm.totalcount)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }